import { render } from "./Dashboard.vue?vue&type=template&id=01801324&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "primevue/resources/primevue.min.css?vue&type=style&index=1&lang=css"
import "primevue/resources/themes/saga-blue/theme.css?vue&type=style&index=2&lang=css"
import "./Dashboard.vue?vue&type=style&index=3&id=01801324&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=4&id=01801324&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01801324"]])

export default __exports__